import React from "react";

import styled from "@mui/material/styles/styled";

import TableCell from "@app/analytics/components/Table/TableCell";
import { getInitials } from "@app/common/utils";

import Avatar from "@rui/Avatar";
import { Row } from "@rui/Stack";
import TooltipWrapper from "@rui/TooltipWrapper";

export const OwnerTableCell = styled(TableCell)(({ theme }) => ({
  color: theme.palette.shades.neutral[500],
  width: "80px",
  [theme.breakpoints.down("sm")]: {
    alignContent: "start",
    width: "auto",
  },
}));

const OwnerCell = ({
  asCell = true,
  owner,
}: {
  asCell?: boolean;
  owner?: string;
}) => {
  const Wrapper = asCell ? OwnerTableCell : React.Fragment;
  return (
    <Wrapper>
      <Row variant="center">
        <TooltipWrapper title={owner} enterDelay={500}>
          <Avatar name={owner}>{getInitials(owner ?? "")}</Avatar>
        </TooltipWrapper>
      </Row>
    </Wrapper>
  );
};

export default OwnerCell;
